import { instance } from "libs/api";
import {
  DriverDeliveriesReportItem,
  DriverInDeliveriesListItem
} from "modules/financial";

import {
  CompanyDriverDeliveriesParams,
  CompanyDriverDeliveriesResponse,
  CompanyFinanceParams
} from "./companyFinance.types";

const base = (companyId: string) =>
  `/admin/delivery-companies/${companyId}/profile/finance`;

export const requestCompanyFinanceDrivers = (
  companyId: string,
  params: CompanyFinanceParams
): Promise<DriverInDeliveriesListItem[]> =>
  instance.get(`${base(companyId)}/drivers`, { params });

export const requestCompanyDriverDeliveries = (
  companyId: string,
  { driverId, ...params }: CompanyDriverDeliveriesParams
): Promise<CompanyDriverDeliveriesResponse> =>
  instance.get(`${base(companyId)}/drivers/${driverId}/deliveries`, { params });

export const requestCompanyFinanceReport = (
  companyId: string,
  params: CompanyFinanceParams
): Promise<DriverDeliveriesReportItem[]> =>
  instance.get(`${base(companyId)}/report`, { params });
